/* Squishy Vault Bento 1a (Claude 01.11.2026): Geschenk-Stufen gold markieren, Korbzaehler, Handy-Unterleiste, Mega-Menue schliessen.
   Rechnet NICHT selbst: Stufen/Betraege kommen aus sv-vault.js (SV.stufenAktiv, sv-bonus data-sub). */
(function () {
  'use strict';
  var SV = window.SV || {};

  function geld(cent) {
    try {
      var cur = (SV.korb && SV.korb.cur) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(SV.intl || document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(cent / 100);
    } catch (e) { return (cent / 100).toFixed(2); }
  }

  /* Geschenk-Section: erreichte Stufen markieren, nicht verfuegbare Stufen (Markt ohne Gratisversand) ausblenden */
  function geschenke() {
    document.querySelectorAll('[data-svb-geschenke]').forEach(function (box) {
      var bonus = box.querySelector('sv-bonus');
      if (!bonus || typeof SV.stufenAktiv !== 'function') return;
      var sub = parseInt(bonus.getAttribute('data-sub') || '0', 10) || 0;
      var akt = SV.stufenAktiv(true);
      var summe = box.querySelector('[data-svb-korbsumme]');
      if (summe) summe.textContent = geld(sub);
      [].forEach.call(box.querySelectorAll('[data-stufe]'), function (el) {
        var n = +el.getAttribute('data-stufe');
        var a = akt.filter(function (x) { return x.n === n; })[0];
        el.hidden = !a;
        if (a && sub >= a.w) el.setAttribute('data-erreicht', ''); else el.removeAttribute('data-erreicht');
      });
    });
  }

  function zaehler(n) {
    document.querySelectorAll('[data-svb-zahl]').forEach(function (el) {
      el.textContent = el.closest('.svb-unten') ? (n > 0 ? n : '') : n;
    });
  }
  function korbHolen() {
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { zaehler(c.item_count || 0); setTimeout(geschenke, 50); })
      .catch(function () {});
  }
  document.addEventListener('cart:update', function () { setTimeout(korbHolen, 300); });
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.promise && e.promise.then) e.promise.then(korbHolen, korbHolen); else setTimeout(korbHolen, 700);
  });

  /* sv-bonus zeichnet bei data-sub-Aenderung neu -> danach Stufen markieren */
  function beobachten() {
    document.querySelectorAll('[data-svb-geschenke] sv-bonus').forEach(function (b) {
      new MutationObserver(geschenke).observe(b, { attributes: true, attributeFilter: ['data-sub', 'data-stufe'] });
    });
  }

  /* Handy-Unterleiste: Suche + Korb nutzen vorhandene Theme-Bedienung */
  document.addEventListener('click', function (e) {
    var su = e.target.closest('[data-svb-suche]');
    if (su) {
      var lk = document.querySelector('.header__row--top .sv-suche__lupe-knopf');
      if (lk && lk.offsetParent !== null) { e.preventDefault(); lk.click(); return; }
      var feld = document.getElementById('sv-suche-feld');
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') { e.preventDefault(); modal.showDialog(); return; }
      if (feld && feld.offsetParent !== null && getComputedStyle(feld).display !== 'none') { e.preventDefault(); feld.focus(); }
      return;
    }
    var ko = e.target.closest('[data-svb-korb]');
    if (ko) {
      var knopf = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (knopf) { e.preventDefault(); knopf.click(); }
      return;
    }
    /* Mega-Menue: Klick ausserhalb schliesst */
    document.querySelectorAll('details.svb-mega[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('details.svb-mega[open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });

  function start() { beobachten(); geschenke(); setTimeout(geschenke, 800); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
